import { useOutletContext } from "react-router-dom";
import { Hero } from "../components/macaron/Hero";
import { Platform } from "../components/macaron/Platform";
import { FinalCTA } from "../components/macaron/FinalCTA";

export default function ProductPage() {
  const { openContact } = useOutletContext();
  return (
    <>
      <Hero onContact={openContact} />
      <Platform onContact={openContact} />
      <FinalCTA onContact={openContact} />
    </>
  );
}
